module.exports = __webpack_public_path__ + "media/landing-desktop/assets/images/image-error-9a47722ddaa37673c4f7aed995f09d7b.svg";